<template>
    <div class="franchise-modals-container">
      <section v-if="show_buttons">
        <ul class="nav nav-tabs tabs__funnel" role="tablist" v-if="!loading">
            <!-- autoresponder -->
            <li role="presentation">
                <a
                    aria-controls="messages"
                    data-target="#autoresponder"
                    class="d-button"
                    @click="toggleModalAutoresponderEventListener"
                    v-html="view.translations.autoresponder.funnel_tab_autoresponder"
                ></a>
            </li>

            <!-- connect / disconnect domain -->
            <li
                v-if="view.data.user_domain_share !== undefined && view.data.user_domain_share !== null"
                class="btn-group selection__type--lenguage-out"
            >
                <a
                    class="selection__type--lenguage dropdown-toggle d-button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {{view.translations.domain.dns_domain}}
                </a>
                <ul class="dropdown-menu">
                    <li id="btn-disconnect-domain">
                        <a id="btn-domain-share" data-type="2" @click.prevent="toggleModalDisconnectFunnelsEventListener()">
                            {{view.translations.domain.office2_autopilot_share_desconectar_dominio}}
                        </a>
                    </li>
                    <li id="btn-disconnect-domain">
                        <a id="btn-ns" @click.prevent="toggleModalModalDomainDNSEventListener()">
                            {{view.translations.domain.dns_ns_servers}}
                        </a>
                    </li>
                </ul>
            </li>
            <li v-else>
                <a id="btn-domain-share" class="d-button" data-type="1" @click.prevent="toggleModalConnectFunnelsEventListener()">
                    {{view.translations.domain.label_conectar_dominio}}
                </a>
            </li>

            <!-- Gerador de Links  -->
            <li class="btn-group selection__type--lenguage-out">
                <a
                    class="selection__type--lenguage dropdown-toggle d-button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {{view.translations.link_generator.link_generator}}
                </a>
                <ul class="dropdown-menu">
                    <li>
                        <a
                            data-target="#createUrlRedirModal"
                            @click="toggleModalRedirectLinkEventListener"
                        >
                            {{view.translations.link_generator.office2_autopilot_share_urlredir}}
                        </a>
                    </li>
                    <li>
                        <a
                            data-target="#linkMagicFunnel"
                            id="btnMagicFunnelLinkGenerator"
                            ref="btnMagicFunnelLinkGenerator"
                            @click="toggleModalMagicFunnelEventListener"
                        >
                            {{view.translations.link_generator.link_generator_magic_funnel}}
                        </a>
                    </li>
                    <li>
                        <a
                            data-target="#linkWhatsApp"
                            @click="toggleModalWhatsappEventListener"
                        >
                            {{view.translations.link_generator.link_generator_whatsapp}}
                        </a>
                    </li>
                    <li>
                        <a
                            data-target="#linkTelegram"
                            @click="toggleModalTelegramEventListener"
                        >
                            {{view.translations.link_generator.link_generator_telegram}}
                        </a>
                    </li>
                    <li>
                        <a
                            id="submit_short_url_list_1"
                            @click="accessShortUrl"
                        >
                            {{view.translations.link_generator.link_generator_url_shortener}}
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="loading-buttons" v-else>
            <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
        </div>
      </section>

        <!-- modal autoresponder -->
        <autoresponder-v5 @toggleAutoresponder="toggleModalAutoresponderEventListener"/>

        <!-- modais de dominio incluidos no arquivo global modals.phtml -->

        <!-- modal redirect link -->
        <modal-redirect-link-v5 :accessShortUrlFunc="accessShortUrl" />

        <!-- modal magic funnel -->
        <modal-magic-funnel-v5
            :parentRefs="{
                btnMagicFunnelLinkGenerator: $refs.btnMagicFunnelLinkGenerator
            }"
        />

        <!-- modal whatsapp -->
        <modal-whatsapp-v5 />

        <!-- modal telegram -->
        <modal-telegram-v5 />

        <!-- modal URL shortner = NAO TEM. REDIRECT-->
    </div>
</template>

<script>
    export default {
        props: {
          show_buttons: {
            type: Boolean,
            default: true
          }
        },
        name: 'ba-franchise-modals-v5',
        data: function() {
            return {
                //autoresponder
                openModalAutoresponder: false,

                //modais de dominio
                openModalConnectFunnels: false,
                openModalDisconnectFunnels: false,
                openModalDomainNS: false,

                //link generator
                openModalRedirectLink: false,
                openModalMagicFunnel: false,
                openModalWhatsapp: false,
                openModalTelegram: false,

                // params
                openTool: null,

                //data
                lang: window.lang || 'us',
                loading: true,
                pageLoaded: false,
                calledOpen: false,
                view: { // prevent undefined bugs
                    data: {
                        host_short_url: '',
                        user_domain_share: '',
                    },
                    translations: {
                        autoresponder: {},
                        domain: {},
                        link_generator: {}
                    }
                },
            }
        },
        methods: {

            // toggle modal autoresponder event listener
            toggleModalAutoresponderEventListener() {
                this.openModalAutoresponder = !this.openModalAutoresponder
                if(this.openModalAutoresponder){
                    $('#autoresponder').modal('show')
                } else {
                    $('#autoresponder').modal('hide')
                }
            },

            // toggle Modal Connect Funnels  event listener
            toggleModalConnectFunnelsEventListener() {
                this.openModalConnectFunnels = !this.openModalConnectFunnels
                if(this.openModalConnectFunnels){
                    $('#modalConnectFunnels').modal('show')
                }
            },

            // toggle Modal disconnect Funnels  event listener
            toggleModalDisconnectFunnelsEventListener() {
                this.openModalDisconnectFunnels = !this.openModalDisconnectFunnels
                if(this.openModalDisconnectFunnels){
                    $('#modalDisconnectFunnels').modal('show')
                }
            },

            // toggle Modal domain DNS  event listener
            toggleModalModalDomainDNSEventListener() {
                this.openModalDomainNS = !this.openModalDomainNS
                if(this.openModalDomainNS){
                    $('#modalDomainNS').modal('show')
                }
            },

            // toggle modal redirect link event listener
            toggleModalRedirectLinkEventListener() {
                this.openModalRedirectLink = !this.openModalRedirectLink
                if(this.openModalRedirectLink){
                    let vm = this
                    $('#createUrlRedirModal').modal({ show: vm.openModalRedirectLink })
                }
            },

            // toggle modal Magic Funnel event listener
            toggleModalMagicFunnelEventListener() {
                this.openModalMagicFunnel = !this.openModalMagicFunnel
                if(this.openModalMagicFunnel){
                    let vm = this
                    $('#linkMagicFunnel').modal({ show: vm.openModalMagicFunnel })
                }
            },
            // toggle modal Whatsapp event listener
            toggleModalWhatsappEventListener() {
                this.openModalWhatsapp = !this.openModalWhatsapp
                if(this.openModalWhatsapp){
                    let vm = this
                    $('#linkWhatsApp').modal({ show: vm.openModalWhatsapp })
                }
            },

            // toggle modal Telegram event listener
            toggleModalTelegramEventListener() {
                this.openModalTelegram= !this.openModalTelegram
                if(this.openModalTelegram){
                    let vm = this
                    $('#linkTelegram').modal({ show: vm.openModalTelegram })
                }
            },

            accessShortUrl(){
                window.open(this.view.data.access_short_url, '_blank')
                // let vm = this
                // //Busca o token
                // let auth = btoa('builderall:EGb5jmeN');
                // $.ajax({
                //     url: `${vm.view.data.host_short_url}/api/v1/auth`,
                //     type: 'GET',
                //     async: false,
                //     contentType: 'application/json; charset=utf-8',
                //     headers: {
                //         "Authorization": "Basic " + auth
                //     },
                //     dataType: 'json',
                //     success: function(response) {
                //         if (response.status == 'success' && response.token != null) {
                //             $('#token').val(response.token);

                //             $('#form-list-short-url').submit();
                //         } else {
                //             alertMsg('error', 'Error generate short url token!');
                //         }
                //     },
                //     error: function(response) {
                //         console.log(response);
                //     }
                // });
            },

            requestDataMainButtons: async function (){
                this.loading = true
                try{
                    let res = await axios.get(`/${this.lang}/office/franchise-system/main-component/data`)
                    res = res.data.data
                    this.$set(this.$data, 'view', res)
                } catch(e) {
                    console.log('error = ', e.getMessage())
                } finally {
                    this.loading = false
                }
            },
            openModalbySideMenu(){
                // OPEN MODAL
                this.openTool = new URL(location.href).searchParams.get('opentool');
                if(this.openTool !== undefined && this.openTool !== null) {
                    switch (this.openTool) {
                        case 'autoresponder':
                            this.toggleModalAutoresponderEventListener();
                            break;
                        case 'connect_domain':
                            this.toggleModalConnectFunnelsEventListener()
                            break;
                        case 'disconnect_domain':
                            this.toggleModalDisconnectFunnelsEventListener();
                            break;
                        case 'name_servers':
                            this.toggleModalModalDomainDNSEventListener()
                            break;
                        case 'createUrlRedirModal':
                            this.toggleModalRedirectLinkEventListener();
                            break;
                        case 'linkMagicFunnel':
                            this.toggleModalMagicFunnelEventListener();
                            break;
                        case 'linkWhatsApp':
                            this.toggleModalWhatsappEventListener();
                            break;
                        case 'linkTelegram':
                            this.toggleModalTelegramEventListener();
                            break;
                        case 'submit_short_url_list_1':
                            this.accessShortUrl();
                            break;
                    }
                    this.calledOpen = true
                }
            }
        },
        created: async function () {
            this.requestDataMainButtons()
        },
        mounted(){
            let vm = this

            // hide modal autoresponder event listener
            // $('#autoresponder').on('hidden.bs.modal', function() {
            //     vm.toggleModalAutoresponderEventListener()
            // })

            // hide modal connect funnels event listener
            $('#modalConnectFunnels').on('hidden.bs.modal', this.toggleModalConnectFunnelsEventListener)

            // hide modal disconnect funnels event listener
            $('#modalDisconnectFunnels').on('hidden.bs.modal', this.toggleModalDisconnectFunnelsEventListener)

            // hide modal domain dns event listener
            $('#modalDomainNS').on('hidden.bs.modal', this.toggleModalModalDomainDNSEventListener)

            // hide modal Redirect Link event listener
            $('#createUrlRedirModal').on('hidden.bs.modal', this.toggleModalRedirectLinkEventListener)

            // hide modal Magic Funnel event listener
            $('#linkMagicFunnel').on('hidden.bs.modal', this.toggleModalMagicFunnelEventListener)

            // hide modal Whatsapp event listener
            $('#linkWhatsApp').on('hidden.bs.modal', this.toggleModalWhatsappEventListener)

            // hide modal Telegram event listener
            $('#linkTelegram').on('hidden.bs.modal', this.toggleModalTelegramEventListener)

            document.onreadystatechange = () => {
                if (document.readyState == "complete") {
                    vm.pageLoaded = true
                }
            }
        },
        watch: {
            loading: function(newVal, oldVal) {
                if( !this.calledOpen && !newVal && this.pageLoaded ) {
                    this.openModalbySideMenu()
                }
            },
            pageLoaded: function(newVal, oldVal) {
                if( !this.calledOpen && newVal && !this.loading ) {
                    this.openModalbySideMenu()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .franchise-modals-container{
        margin-bottom: 14px;
        .tabs__funnel{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: auto;

            justify-content: stretch;
            justify-items: stretch;
            align-items: stretch;
            align-content: stretch;

            row-gap: 14px;
            column-gap: 8px;


            &::before,
            &::after{
                display: none;
            }
            min-width: 100%;
            li{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;

                a,
                .dropdown-menu{
                    min-width: 100%;
                }
            }
        }
        .loading-buttons{
            height: 50px;
            text-align: center;
            border: 1px #f0f0f0 solid;
            border-radius: 8px;
            .modal-loader{
                height: 40px;
                width: auto;
            }
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .franchise-modals-container{
            .tabs__funnel{
                grid-template-columns: auto;
                grid-template-rows: repeat(3, 1fr);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/modals/index.vue